import { NavLink } from "react-router-dom";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import useFetch from "../hooks/useFetch.js";
import homelap from "../assets/Home/homelap2.webp";
import homemob from "../assets/Home/Image chart.png";
import recright from "../assets/Home/recright.webp";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import homeflowmobile2 from "../assets/Home/mobile.webp";
import { Helmet } from "react-helmet-async";
import functional from "../assets/Home/Functional AI.png";
import business from "../assets/Home/Business enterprise Suit.png";
import triangle from "../assets/Managed/triangle.webp";
import Lottie from "react-lottie";
import loading from "../pages/loading.json";
import { motion } from "framer-motion";
import logo1 from "../assets/Home/AXI 1.png";
import logo2 from "../assets/Home/fueltrans.png";
import logo3 from "../assets/Home/Greater_Chennai_Police_Logo.png";
import logo4 from "../assets/Home/TEAM CATALYST.png";
import logo5 from "../assets/Home/TQ Consulting.png";
import logo6 from "../assets/Home/nagpur police logo.png";
import logo7 from "../assets/Home/Mumbai_Police_logo.png";

import logo9 from "../assets/Home/indainpremier.png";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import yelloww5 from "../assets/Home/yellow5.webp";
import { Client, Databases, ID } from "appwrite";

// import home from "../assets/Home/home.gif";

import "react-phone-input-2/lib/style.css";
import config from "../config/config.js";
import Popup from "../components/popup.js";
function titleToSlug(title) {
  return title
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

const Home = ({ utmContent }) => {
  const logos = [
    { id: 1, name: "Company 1", image: logo1 },
    { id: 2, name: "Company 2", image: logo2 },
    { id: 3, name: "Company 3", image: logo3 },
    { id: 4, name: "Company 4", image: logo4 },
    { id: 5, name: "Company 5", image: logo5 },
    { id: 6, name: "Company 6", image: logo6 },
    { id: 7, name: "Company 7", image: logo7 },
   
    { id: 9, name: "Company 8", image: logo9 },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessemail, setEmailId] = useState("");
  const [projectdetails, setprojectdetails] = useState("");

  // const [utmSource, setUtmSource] = useState("");
  // const [utmMedium, setUtmMedium] = useState("");
  // const [utmCampaign, setUtmCampaign] = useState("");
  // const [utmId, setUtmId] = useState("");
  // const [utmTerm, setUtmTerm] = useState("");
  // const [utmContent, setUtmContent] = useState("");

  const [utmParams, setUtmParams] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_id: "",
    utm_term: "",
    utm_content: "",
  });
  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setfirstname("");
    setlastname("");
    setPhoneNumber("");
    setCompanyName("");
    setEmailId("");
    setprojectdetails("");
    setIsChecked(true);
    setErrors({});
  };
  const handleButtonClickcontact = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  const handlePhoneNumberChange = (number, country) => {
    setPhoneNumber(number);

    try {
      // Ensure number starts with +
      const fullNumber = number.startsWith("+") ? number : `+${number}`;

      // Check if the number is valid for the selected country
      if (isValidPhoneNumber(fullNumber)) {
        const phoneNumberObj = parsePhoneNumberFromString(fullNumber);
        const nationalNumber = phoneNumberObj.nationalNumber;

        // Get expected length based on country
        const expectedLength = phoneNumberObj.nationalNumber?.length;
        const actualLength = nationalNumber?.length;

        if (actualLength < expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too short - needs ${expectedLength} digits`,
          }));
        } else if (actualLength > expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too long - should be ${expectedLength} digits`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setErrors((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid phone number",
      }));
    }
  };

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);

  //   setUtmSource(searchParams.get("utm_source") || "");
  //   setUtmMedium(searchParams.get("utm_medium") || "");
  //   setUtmCampaign(searchParams.get("utm_campaign") || "");
  //   setUtmId(searchParams.get("utm_id") || "");
  //   setUtmTerm(searchParams.get("utm_term") || "");
  //   setUtmContent(searchParams.get("utm_content") || "");
  // }, []);

  useEffect(() => {
    const captureUtmParams = () => {
      console.log(utmContent);
      const params = new URLSearchParams(window.location.search);
      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
      ];

      const newUtmParams = {
        utm_content: utmContent,
      };
      utmFields.forEach((field) => {
        newUtmParams[field] = params.get(field) || "";
      });
      console.log(newUtmParams);
      setUtmParams(newUtmParams);
    };

    captureUtmParams();
    window.addEventListener("popstate", captureUtmParams);

    return () => {
      window.removeEventListener("popstate", captureUtmParams);
    };
  }, [utmContent]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      // Validate phone number first
      if (!phoneNumber) {
        setErrors({ phoneNumber: "Phone number is required" });
        setIsLoading(false);
        return;
      }

      const fullNumber = phoneNumber.startsWith("+")
        ? phoneNumber
        : `+${phoneNumber}`;

      if (!isValidPhoneNumber(fullNumber)) {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
        setIsLoading(false);
        return;
      }

      const formData = {
        firstname,
        lastname,
        businessemail,
        companyName,
        phoneNumber,
        projectdetails,
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmCampaign: utmParams.utm_campaign,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
      };

      // First, save to Appwrite
      await Promise.all([
        databases.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          config.collectionIds.contactForm,
          ID.unique(),
          formData
        ),

        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/submit-form`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }).then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to submit form");
          }
        }),
      ]);

      // Close the modal and show success message
      setIsModalOpen(false);
      setIsSuccessOpen(true);
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
  };
  const signupRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === "#signup") {
      signupRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const [isChecked, setIsChecked] = useState(true);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  useEffect(() => {
    // Set page title
    document.title =
      "Random Walk | Advanced AI Solutions for Modern Enterprises";

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Start your AI journey with Random Walk AI—your expert in cutting-edge AI solutions, AI training, and AI integration services. Empower your business with tailored strategies and AI services."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Start your AI journey with Random Walk AI—your expert in cutting-edge AI solutions, AI training, and AI integration services. Empower your business with tailored strategies and AI services.";
      document.head.appendChild(meta);
    }

    // Add or update Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute(
      "content",
      "Random Walk | Advanced AI Solutions for Modern Enterprises"
    );

    // Add or update Open Graph description
    let ogDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (!ogDescription) {
      ogDescription = document.createElement("meta");
      ogDescription.setAttribute("property", "og:description");
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute(
      "content",
      "Start your AI journey with Random Walk AI—your expert in cutting-edge AI solutions, AI training, and AI integration services. Empower your business with tailored strategies and AI services."
    );

    // Add viewport meta tag
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.head.appendChild(viewport);
    }
    viewport.setAttribute("content", "width=device-width, initial-scale=1");

    // Add theme-color meta tag
    let themeColor = document.querySelector('meta[name="theme-color"]');
    if (!themeColor) {
      themeColor = document.createElement("meta");
      themeColor.name = "theme-color";
      document.head.appendChild(themeColor);
    }
    themeColor.setAttribute("content", "#000000");

    // Add Open Graph image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement("meta");
      ogImage.setAttribute("property", "og:image");
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute("content", `${process.env.PUBLIC_URL}/rw_logo.png`);

    // Add Open Graph type
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement("meta");
      ogType.setAttribute("property", "og:type");
      document.head.appendChild(ogType);
    }
    ogType.setAttribute("content", "website");

    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = "https://randomwalk.ai/";
  }, []);

  useEffect(() => {
    const captureUtmParams = () => {
      const params = new URLSearchParams(window.location.search);
      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
        "utm_content",
      ];

      const newUtmParams = { utm_content: utmContent };
      utmFields.forEach((field) => {
        newUtmParams[field] = params.get(field) || "";
      });
      setUtmParams(newUtmParams);
    };

    captureUtmParams();
    window.addEventListener("popstate", captureUtmParams);

    return () => {
      window.removeEventListener("popstate", captureUtmParams);
    };
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % logos.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const getLogoStyle = (position) => {
    const distance = Math.abs(position);

    if (position === 0) {
      // Center logo - highlighted and larger
      return {
        transform: "scale(1.3)",
        opacity: 1,
        filter: "blur(0px)",
        zIndex: 10,
      };
    } else if (distance === 1) {
      // Adjacent logos
      return {
        transform: "scale(0.9)",
        opacity: 0.6,
        filter: "blur(1px)",
        zIndex: 5,
      };
    } else if (distance === 2) {
      // Second adjacent logos
      return {
        transform: "scale(0.75)",
        opacity: 0.4,
        filter: "blur(2px)",
        zIndex: 3,
      };
    } else {
      // Far logos - more blurred
      return {
        transform: "scale(0.6)",
        opacity: 0.2,
        filter: "blur(3px)",
        zIndex: 1,
      };
    }
  };

  const getVisibleLogos = () => {
    const visible = [];
    const totalLogos = logos.length;

    // Show 5 logos at a time (2 left, center, 2 right)
    for (let i = -2; i <= 2; i++) {
      const index = (currentIndex + i + totalLogos) % totalLogos;
      visible.push({
        logo: logos[index],
        position: i,
      });
    }

    return visible;
  };

  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={homemob} />
      </Helmet>

      <div className="body font-display cus4:container cus4:mx-auto ">
        {isModalOpen && (
          <section className="fixed z-50 inset-0 md:p-0 lg:px-20 p-12 bg-[rgba(0,0,0,0.5)] flex items-center justify-center">
            <div className="relative bg-[#F1F6FF]   p-8 lg:px-10 rounded-lg max-h-screen   max-w-md w-full">
              <a
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeModal}
              >
                <svg
                  className="lg:w-6 lg:h-6 w-4 h-4 cursor-pointer"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </a>
              {/* <div className='text-lg md:text-xl text-center font-bold mb-4'>
                  Experience the Power of Data <br />
                  With
                  <span className='text-[#C62B6D] font-bold'> AI Fortune </span>
                  Cookie
                </div> */}
              <form onSubmit={handleSubmit}>
                <div className="max-h-[400px] overflow-y-auto custom-scrollbar pr-4 ">
                  <div className="mb-2">
                    <label className=" text-gray-700">First Name</label>
                    <input
                      id="firstname"
                      type="text"
                      name="firstname"
                      value={firstname}
                      onChange={(e) => setfirstname(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                      required
                    />
                    {errors.firstname && (
                      <p className="text-red-500 text-sm">{errors.firstname}</p>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className=" text-gray-700">Last Name</label>
                    <input
                      type="text"
                      name="lastname"
                      id="lastname3"
                      value={lastname}
                      onChange={(e) => setlastname(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                      required
                    />
                    {errors.lastname && (
                      <p className="text-red-500 text-sm">{errors.lastname}</p>
                    )}
                  </div>
                  <div className="mb-2">
                    <label id="Phonenumber" className=" text-gray-700">
                      Phone Number
                    </label>
                    <PhoneInput
                      country={"in"}
                      value={phoneNumber}
                      onChange={(number, country) =>
                        handlePhoneNumberChange(number, country)
                      }
                      inputClass="custom-phone-input2 "
                      buttonClass="border rounded"
                      dropdownClass="border rounded"
                      required
                      enableSearch={true}
                      inputProps={{
                        required: true,
                        autoFocus: false,
                      }}
                    />
                    {errors.phoneNumber && (
                      <p className="text-red-500 text-sm">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className="text-gray-700">Company Name</label>
                    <input
                      id="Companyname"
                      type="text"
                      name="companyName"
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                      required
                    />
                    {errors.companyName && (
                      <p className="text-red-500 text-sm">
                        {errors.companyName}
                      </p>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className=" text-gray-700">Business Email</label>
                    <input
                      id="businessemail"
                      type="email"
                      name="businessemail"
                      value={businessemail}
                      onChange={(e) => setEmailId(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                      required
                    />
                    {errors.businessemail && (
                      <p className="text-red-500 text-sm">
                        {errors.businessemail}
                      </p>
                    )}
                  </div>

                  <div className="mb-4">
                    <label className=" text-gray-700">
                      Project Details(Optional)
                    </label>
                    <input
                      id="projectdetails"
                      type="text"
                      name="projectdetails"
                      value={projectdetails}
                      onChange={(e) => setprojectdetails(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                    />
                    {errors.companyName && (
                      <p className="text-red-500 text-sm">
                        {errors.companyName}
                      </p>
                    )}
                  </div>
                  <div className="disclaimerContainercontact">
                    <label className="checkboxLabel">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        className="checkbox"
                      />
                      <span className="checkboxText">
                        I agree and authorize team to contact me and/or send
                        relevant information over Email, SMS & WhatsApp. This
                        will override the registry with DNC/NDNC.
                      </span>
                    </label>
                  </div>
                  {errors.terms && (
                    <p className="text-red-500 text-sm">{errors.terms}</p>
                  )}
                  <div className="linksContainer">
                    <a href="/terms-of-service/" className="link">
                      Terms of Service
                    </a>
                    <a href="/privacy-policy/" className="link">
                      Privacy Policy
                    </a>
                  </div>
                </div>
                <div className="mb-4">
                  <button
                    id="submit"
                    type="submit"
                    className={`w-full px-4 py-2 bg-[#C62B6D] text-white rounded ${
                      !isChecked || isLoading
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                    disabled={!isChecked || isLoading}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg
                          className="animate-spin h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        <span>Submitting...</span>
                      </div>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </section>
        )}

        {isSuccessOpen && (
          <section className="fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)]  flex items-center justify-center">
            <div className="relative bg-white p-8 rounded-lg max-w-md w-full text-center">
              <a
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeSuccessModal}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </a>
              <h2 className="text-2xl font-bold mb-4">Success!</h2>
              <p className="mb-4">Your request has been sent successfully.</p>
              <button
                id="close"
                className="px-4 py-2 bg-[#C62B6D] text-white rounded"
                onClick={closeSuccessModal}
              >
                Close
              </button>
            </div>
          </section>
        )}

        <section className="font-display bg-[#3E59B7] lg:h-screen md:py-12 lg:py-16 flex flex-col md:flex-row justify-start items-center 2xl:justify-center px-12 md:px-0">
          {/* Text Content Animates from LEFT */}
          <article className="flex items-center mt-24 md:mt-10 lg:mt-0 justify-center text-left md:px-10 lg:px-16 md:text-left">
            <motion.div
              initial={{ opacity: 0, x: -200 }} // start off-screen left
              animate={{ opacity: 1, x: 0 }} // move to normal position
              transition={{ duration: 1, ease: "easeOut" }} // smooth motion
              className="text-white"
            >
              {/* Headings */}
              <h2 className="text-[20px] 2xl:hidden text-left md:text-[24px] md:mt-5 lg:text-[32px] 2xl:text-[60px] font-bold md:mb-6 mb-3 lg:max-w-6xl">
                Smarter Systems.
                <br />
                Seamless Decisions.
              </h2>

              <h2 className="text-xl max-2xl:hidden text-left  md:mt-5  2xl:text-[60px] font-bold md:mb-6 mb-3 leading-snug">
                Smarter Systems.
                <br /> Seamless Decisions.
              </h2>

              {/* Paragraph */}
              <p className="md:text-[12px] text-[12px] lg:text-[18px] 2xl:text-[24px] font-medium max-w-6xl mb-6">
                We build AI solutions that think with your business. From
                automated insights to conversational systems, our
                enterprise-grade platforms are designed for intelligence,
                security, and impact — custom-fit to your goals.
              </p>

              {/* Buttons Row */}
              <div className="flex gap-4">
                <Link
                  to="/platform"
                  className="flex items-center gap-2 border border-white text-[14px] md:text-[16px] 2xl:text-[18px] hover:bg-white hover:text-[#3E59B7] font-semibold py-3 px-8 rounded-md shadow-md transition duration-300"
                >
                  Explore Platforms
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="#ffffff"
                    className="w-5 h-5 hover:stroke-[#3E59B7]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </Link>

                <button
                  className="flex items-center gap-2 border bg-white text-[#3E59B7] text-[14px] md:text-[16px] 2xl:text-[18px] hover:bg-[#3E59B7] hover:border-white hover:text-white font-semibold py-3 px-8 rounded-md shadow-md transition duration-300"
                  onClick={handleButtonClickcontact}
                >
                  Book a Demo
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="#ffffff"
                    className="w-5 h-5 hover:stroke-[#3E59B7]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>
            </motion.div>
          </article>

          {/* Image Animates from RIGHT */}
          <motion.figure
            initial={{ opacity: 0, x: 200 }} // start off-screen right
            animate={{ opacity: 1, x: 0 }} // slide to position
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="max-md:hidden md:mt-12 md:mx-16 lg:mx-0"
          >
            <picture>
              <img
                src={homemob}
                alt="RandomWalk"
                className="md:w-[900px] md:h-[400px] lg:w-[1050px] lg:h-[450px] 2xl:w-[750px] 2xl:h-[620px] object-contain"
              />
            </picture>
          </motion.figure>

          {/* Mobile Image (optional animation for small screens) */}
          <motion.figure
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="block md:hidden pb-4 md:p-3"
          >
            <img
              src={homemob}
              alt="RandomWalk"
              className="w-[300px] h-[300px] max-w-full"
            />
          </motion.figure>
        </section>
        <div className="bg-white py-8 px-4 flex items-center justify-center">
          <div className="max-w-6xl mx-auto w-full">
            <div className="relative overflow-hidden py-12">
              {/* Left blur gradient */}
              <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-20 pointer-events-none"></div>

              {/* Right blur gradient */}
              <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-20 pointer-events-none"></div>

              {/* Logo container */}
              <div className="flex items-center justify-center gap-8 px-16">
                {getVisibleLogos().map(({ logo, position }) => (
                  <div
                    key={`${logo.id}-${position}`}
                    className="flex-shrink-0 transition-all duration-500 ease-out"
                    style={getLogoStyle(position)}
                  >
                    <div className="bg-white rounded-lg shadow-lg p-6 flex items-center justify-center w-48 h-32">
                      <img
                        src={logo.image}
                        alt={logo.name}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Progress indicators */}
       
            </div>
          </div>
        </div>
        <h2 className="font-bold md:hidden text-[24px] pt-5 md:text-[24px] pb-3 lg:text-[40px] 2xl:text-[60px] text-[#666666] px-12">
          Our AI Platform Suite
        </h2>

        <h2 className="font-bold text-[20px] max-md:hidden md:text-[20px] lg:text-[32px] 2xl:text-[44px] text-[#666666] pt-10 md:pt-12 2xl:mt-5 md:px-12 lg:px-24 2xl:px-40">
          Our AI Platform Suite
        </h2>

        <p className="text-center text-[#666666] text-[14px] md:text-[16px] lg:text-[18px] 2xl:text-[20px] font-medium lg:max-w-5xl  mx-auto px-6 pt-4">
          Discover a suite of AI platforms built to meet every enterprise
          challenge. From vision and voice to data and decision-making. Each
          platform is engineered for adaptability, security, and seamless
          integration, empowering businesses to harness intelligence their own
          way.
        </p>

        <section className="hidden lg:grid grid-cols-3 gap-6 md:px-10 md:pb-10 mt-10 mb-20">
          {/* Box 1 */}
          <article
            className="p-8 bg-gradient_background7 rounded-2xl text-left text-white shadow-md transition duration-500 ease-in-out
hover:bg-opacity-40 hover:backdrop-blur-lg hover:shadow-2xl hover:border hover:border-white/20"
          >
            {/* Icon box */}
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <img
                src={business}
                alt="Business Enterprise Icon"
                className="w-6 h-6 object-contain"
              />
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Business Enterprise Suite
            </h2>

            {/* Description */}
            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Our flagship suite features AI Readiness Assessment, Knowledge
              Nudge, Chateleon, and Fortune Cookie. Empowering organizations to
              learn, communicate, and make data-driven decisions effortlessly.
            </p>

            <a
              href="/platform#enterprise-bi"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#enterprise-bi";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>

          <article
            className="p-8 bg-gradient_background7 rounded-2xl text-left text-white shadow-md transition duration-500 ease-in-out
hover:bg-opacity-40 hover:backdrop-blur-lg hover:shadow-2xl hover:border hover:border-white/20"
          >
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="#FFFFFF"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Visual AI Platform
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Transform images and videos into actionable intelligence through
              deep learning models that detect, classify, and analyze visual
              data with precision.
            </p>

            <a
              href="/platform#visualaiplatform"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#visualaiplatform";
                // Or if using React Router:
                // navigate('/platform#enterprise-bi');
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>

          {/* Box 3 */}

          {/* Box 4 */}
          <article
            className="p-8 bg-gradient_background7 rounded-2xl text-left text-white shadow-md transition duration-500 ease-in-out
hover:bg-opacity-40 hover:backdrop-blur-lg hover:shadow-2xl hover:border hover:border-white/20"
          >
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 3v18h18M9 17v-6m4 6V9m4 8v-4"
                />
              </svg>
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Analytical AI
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Unlock insights with AI-powered analytics that simplify complex
              data into patterns, predictions, and decisions you can trust.
            </p>

            <a
              href="/platform#analyticalai"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#analyticalai";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>

          {/* Box 5 */}
          <article
            className="p-8 bg-gradient_background7 rounded-2xl text-left text-white shadow-md transition duration-500 ease-in-out
hover:bg-opacity-40 hover:backdrop-blur-lg hover:shadow-2xl hover:border hover:border-white/20"
          >
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300knowledgegroup-hover:scale-110">
              <img
                src={functional}
                alt="Business Enterprise Icon"
                className="w-6 h-6 object-contain"
              />
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Functional AI
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Automate workflows and optimize performance across business
              operations through intelligent task management and adaptive
              process automation.
            </p>

            <a
              href="/platform#functionalai"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#functionalai";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>

          <article
            className="p-8 bg-gradient_background7 rounded-2xl text-left text-white shadow-md transition duration-500 ease-in-out
hover:bg-opacity-40 hover:backdrop-blur-lg hover:shadow-2xl hover:border hover:border-white/20"
          >
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="#FFFFFF"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 8h6M7 12h3M3 6a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2h-4l-4 3-4-3H5a2 2 0 01-2-2V6z"
                />
              </svg>
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Textual AI
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Understand and generate human-like text using natural language
              models that can analyze, summarize, and respond with contextual
              accuracy.
            </p>

            <a
              href="/platform#textualai"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#textualai";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>
        </section>

        <section className="lg:hidden flex scrollbar-hide overflow-x-auto px-5 gap-4 mt-10 mb-32">
          <article className="md:w-6/12 w-11/12 p-5 relative text-white bg-gradient_background7 rounded-xl text-left flex-shrink-0 ">
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <img
                src={business}
                alt="Business Enterprise Icon"
                className="w-6 h-6 object-contain"
              />
            </div>

            {/* Heading */}
            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Business Enterprise Suite
            </h2>

            {/* Description */}
            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Our flagship suite features AI Readiness Assessment, Knowledge
              Nudge, Chateleon, and Fortune Cookie. Empowering organizations to
              learn, communicate, and make data-driven decisions effortlessly.
            </p>

            {/* Learn more link */}
            <a
              href="/platform#enterprise-bi"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#enterprise-bi";
                // Or if using React Router:
                // navigate('/platform#enterprise-bi');
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="#FFFFFF"
      className="w-4 h-4 ml-1"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg> */}
            </a>
          </article>
          <article className="md:w-6/12 w-11/12 p-5 relative text-white bg-gradient_background7 rounded-xl text-left flex-shrink-0">
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2.5}
      stroke="#FFFFFF"
      className="w-7 h-7"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 8h6M7 12h3M3 6a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2h-4l-4 3-4-3H5a2 2 0 01-2-2V6z"
      />
     
    </svg> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 3v18h18M9 17v-6m4 6V9m4 8v-4"
                />
              </svg>
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Analytical AI
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Unlock insights with AI-powered analytics that simplify complex
              data into patterns, predictions, and decisions you can trust.
            </p>

            <a
              href="/platform#analyticalai"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#analyticalai";
                // Or if using React Router:
                // navigate('/platform#enterprise-bi');
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>
          {/* <article className="md:w-6/12 w-11/12 p-5 relative bg-gradient_background7 text-white rounded-xl text-left flex-shrink-0">
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
<svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2.5}
      stroke="#FFFFFF"
      className="w-7 h-7"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  </div>

 
  <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
  Voice AI Platform
  </h2>


  <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
   Enhance conversations with intelligent speech recognition, voice synthesis, and multilingual comprehension built for human-like engagement.

  </p>


  <a
     href="/platform#voiceai"
  onClick={(e) => {
    e.preventDefault();
    window.location.href = '/platform#voiceai';

  }}
    className="ffffflex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
  >
    Learn More
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="#FFFFFF"
      className="w-4 h-4 ml-1"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  </a>
          </article> */}
          <article className="md:w-6/12 w-11/12 p-5 relative bg-gradient_background7 text-white rounded-xl text-left flex-shrink-0">
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2.5}
      stroke="#FFFFFF"
      className="w-7 h-7"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="#FFFFFF"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Visual AI Platform
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Transform images and videos into actionable intelligence through
              deep learning models that detect, classify, and analyze visual
              data with precision.
            </p>

            <a
              href="/platform#visualaiplatforms"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#visualaiplatforms";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>

          <article className="md:w-6/12 w-11/12 p-5 relative bg-gradient_background7 text-white rounded-xl text-left flex-shrink-0">
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <img
                src={functional}
                alt="Business Enterprise Icon"
                className="w-6 h-6 object-contain"
              />
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Functional AI
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Automate workflows and optimize performance across business
              operations through intelligent task management and adaptive
              process automation.
            </p>

            <a
              href="/platform#functionalai"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#functionalai";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>

          <article className="md:w-6/12 w-11/12 p-5 relative bg-gradient_background7 text-white rounded-xl text-left flex-shrink-0">
            <div className="bg-[#FFFFFF] bg-opacity-20 p-3 rounded-xl w-12 h-12 flex items-center justify-center mb-4 transition duration-300 group-hover:scale-110">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="#FFFFFF"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7 8h6M7 12h3M3 6a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2h-4l-4 3-4-3H5a2 2 0 01-2-2V6z"
                />
              </svg>
            </div>

            <h2 className="text-[20px] 2xl:text-[30px] font-semibold mb-2 text-left text-white">
              Textual AI
            </h2>

            <p className="text-gray-200 text-[14px] 2xl:text-[18px] mb-4">
              Understand and generate human-like text using natural language
              models that can analyze, summarize, and respond with contextual
              accuracy.
            </p>

            <a
              href="/platform#textualai"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/platform#textualai";
              }}
              className="flex items-center text-[#FFFFFF] 2xl:text-[24px] font-semibold hover:underline"
            >
              Learn More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="#FFFFFF"
                className="w-4 h-4 ml-1"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </article>
        </section>

        {isSuccessOpen && (
          <section className="fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)] flex items-center justify-center">
            <div className="relative bg-white p-8 rounded-lg max-w-md w-full text-center">
              <a
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeSuccessModal}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </a>
              <h2 className="text-2xl font-bold mb-4">Success!</h2>
              <p className="mb-4">
                Thank you for your interest in becoming a partner!
              </p>
              <button
                id="close"
                className="px-4 py-2 bg-[#C62B6D] text-white rounded"
                onClick={closeSuccessModal}
              >
                Close
              </button>
            </div>
          </section>
        )}

        <section
          className="text-[#666666] min-h-[280px] md:min-h-[300px] relative mt-20 bg-no-repeat bg-cover"
          style={{
            background: "linear-gradient(100deg , #3E59B7 90%, #A6BAFF 110%)", // Example pink gradient
          }}
        >
          <figure className="absolute bottom-0 right-0">
            <img
              src={recright}
              alt="Additional"
              loading="lazy"
              className="lg:w-40 lg:h-auto w-24 h-36 md:w-40 md:h-full"
            />
          </figure>
          <article className="absolute inset-0 flex flex-col justify-center items-center text-center text-white pt-4 md:pt-10 md:mr-32 lg:pt-5 md:ml-20">
            <h2 className="font-bold mb-4 font-display text-[14px] md:text-[20px] lg:text-[24px] 2xl:text-[36px]">
              Transformation begins with ingenuity
            </h2>

            <p className="font-light mb-4 font-display mx-2 text-[12px] md:text-[14px] lg:text-[16px] 2xl:text-[24px] ">
              Our platforms combine innovation and trust, helping enterprises
              uncover insights, streamline operations, and create new value.
              Backed by secure architecture and proven expertise, we empower you
              to move faster and smarter in a world shaped by AI.
            </p>

            <div className="flex gap-4">
              <button
                className="md:mt-3 mb-3 rounded-xl border text-[#3E59B7] bg-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out hover:bg-transparent hover:border hover:border-white hover:text-[#FFFFFF]"
                onClick={handleButtonClickcontact}
              >
                <div className="flex items-center">
                  <span className="font-bold text-[10px] md:text-[18px]">
                    Contact Us
                  </span>
                </div>
              </button>
            </div>
          </article>
        </section>
      </div>
    </>
  );
};
export default Home;
